export default __webpack_public_path__ + "static/media/FENIX.5257a8b8.svg";